import { DashboardFilters } from "@/dashboard/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDashboardRankingsCities } from "../../hooks/use-dashboard-rankings-cities";
import { RankingsDataTable, type RankingsRow } from "../rankings-data-table";

interface DashboardRankingsCitiesDataTableProps {
  filters: DashboardFilters;
}

export const DashboardRankingsCitiesDataTable = ({
  filters,
}: DashboardRankingsCitiesDataTableProps) => {
  const [t] = useTranslation(["dashboard"]);
  const { isLoading, top3RankingData, otherRankingData } =
    useDashboardRankingsCities(filters);

  // O pódio (top 3) deixou de ser cards separados: o Figma mostra o ranking
  // inteiro numa tabela só, na ordem da API.
  const rows = useMemo<RankingsRow[]>(
    () => [...top3RankingData, ...otherRankingData],
    [top3RankingData, otherRankingData],
  );

  return (
    <RankingsDataTable
      data-testid="dashboard-rankings-cities-table"
      rows={rows}
      isLoading={isLoading}
      nameHeader={t("dashboard-rankings-cities-table-header-name") as string}
      valueHeader={t("dashboard-rankings-cities-table-header-value") as string}
    />
  );
};
